import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useUpdate } from '../contexts/UpdateContext';

export const UpdateNotification: React.FC = () => {
  const { updateAvailable } = useUpdate();

  const handleUpdate = () => {
    // 캐시를 지우고 페이지를 새로고침
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    window.location.reload();
  };

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={handleUpdate}>
            지금 업데이트
          </Button>
        }
      >
        새로운 버전이 있습니다. 업데이트하시겠습니까?
      </Alert>
    </Snackbar>
  );
};
